import { createApiSlice } from "@common";
import {
  CRUD_PROSPECT_CONTACT_COMMUNICATION,
  GET_PROSPECT_CONTACT_COMMUNICATION_BY_PROSPECT_CONTACT_ID
} from "@routes";

// 1 to 1
const apiConfig = [
  {
    name: "addProspectContactCommunication",
    method: "post",
    url: CRUD_PROSPECT_CONTACT_COMMUNICATION,
    stateKey: "message",
  },
  {
    name: "getProspectContactCommunicationByProspectContactId",
    method: "get",
    url: GET_PROSPECT_CONTACT_COMMUNICATION_BY_PROSPECT_CONTACT_ID,
    stateKey: "details",
  },
];

const customReducers = {
  initialState: {
    data: [],
    details: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "prospectContactCommunication",
  apiConfig,
  customReducers,
);
const prospectContactCommunicationSlice = slice;

export default prospectContactCommunicationSlice.reducer;

export const {
  addProspectContactCommunication,
  getProspectContactCommunicationByProspectContactId,
} = thunks;

export const { rowSelect } = actions;
